__webpack_require__.p = "/quote-app/";